import React, { useEffect, useState } from "react";
import "../assets/Dashboard.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { parse } from "tldts";

// Quick Access
const quickAccess = [
  {
    id: "customer",
    label: "Customer",
    icon: "fa-solid fa-user",
    className: "quick-customer",
    link: "/CustomerReport",
  },
  {
    id: "employee",
    label: "Employee",
    icon: "fa-solid fa-user-tie",
    className: "quick-employee",
    link: "/EmployeeReport",
  },
  {
    id: "loan",
    label: "Loan",
    icon: "fa-solid fa-hand-holding-dollar",
    className: "quick-loan",
    link: "/LoanReportTest",
  },
  {
    id: "collection",
    label: "Collection",
    icon: "fa-solid fa-money-bill-wave",
    className: "quick-collection",
    link: "/CollectionReportTest",
  },
  {
    id: "due",
    label: "Due",
    icon: "fa-solid fa-clock",
    className: "quick-due",
    link: "/EmiDueReportTest",
  },
  {
    id: "closeAccount",
    label: "Close Account",
    icon: "fa-solid fa-user-slash",
    className: "quick-close-account",
    // link: "/CloseAccount",
    link: "/LoanClosureReport"
  },
  {
    id: "loanScheme",
    label: "Loan Scheme",
    icon: "fa-solid fa-file-contract",
    className: "quick-loan-scheme",
    link: "/LoanScheme",
  },
  {
    id: "fdScheme",
    label: "FD Scheme",
    icon: "fa-solid fa-piggy-bank",
    className: "quick-fd-scheme",
    link: "/FDScheme",
  },
  {
    id: "rdScheme",
    label: "RD Scheme",
    icon: "fa-solid fa-chart-line",
    className: "quick-rd-scheme",
    link: "/RDScheme",
  },
  {
    id: "savingScheme",
    label: "Saving Scheme",
    icon: "fa-solid fa-wallet",
    className: "quick-saving-scheme",
    link: "/SavingScheme",
  },
];

// recent collection dummy data
// const collectionDummyData = [
//   {
//     id: 1,
//     date: "2025-01-05",
//     name: "Rahul Sharma",
//     amount: 1200,
//     mode: "Cash",
//     collector: "Amit Kumar",
//   },
//   {
//     id: 2,
//     date: "2025-01-06",
//     name: "Neha Verma",
//     amount: 2500,
//     mode: "UPI",
//     collector: "Suresh Yadav",
//   },
//   {
//     id: 3,
//     date: "2025-01-07",
//     name: "Imran Khan",
//     amount: 1800,
//     mode: "Bank",
//     collector: "Rohit Singh",
//   },
//   {
//     id: 4,
//     date: "2025-01-08",
//     name: "Pooja Gupta",
//     amount: 3000,
//     mode: "UPI",
//     collector: "Ankit Mishra",
//   },
//   {
//     id: 5,
//     date: "2025-01-09",
//     name: "Sanjay Patel",
//     amount: 1500,
//     mode: "Cash",
//     collector: "Vikas Jain",
//   },
// ];
 const API_URL = "https://payyug.in/api/loan-emi/";
 const collectionDummyData =[

 ];

const Dashboard = () => {
  const navigate = useNavigate();
  const [disbursement, setDisbursement] = useState({
    todayDisbursement: 0,
    weekDisbursement: 0,
    monthDisbursement: 0,
    yearDisbursement: 0,
    allDisbursement:0
  });
 const [collections, setCollections]=useState([]);
 const [dashboardCollections, setDashboardCollections] = useState({
    today: 0,
    week: 0,
    month: 0,
    year: 0,
    total: 0,
  });

  const [totalBranches,setTotalBranches]=useState(0);
  const [totalCustomer,setTotalCustomer]=useState(0);
  const [totalEmployee,setTotalEmployee]=useState(0);
  const [totalActiveLoans,setTotalActiveLoans]=useState(0);
  const [totalPendingLoans,setTotalPendingLoans]=useState(0);

 
 const [dashboardPendingCollections, setDashboardPendingCollections] = useState({
    today: 0,
    week: 0,
    month: 0,
    year: 0,
    total: 0,
  });

  const formatAmount = (value) =>
  Number(value || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });



useEffect(() => {
    const superAdminId = Number(localStorage.getItem("adminuserId")) || 0;

    const fetchCollections = async () => {
      try {
        // setLoading(true);
        const res = await axios.get(`${API_URL}collection-sheet?superAdminId=${superAdminId}`);
        if (res.data && res.data.collections) {
          setCollections(res.data.collections);
        }
      } catch (error) {
        console.error("Error fetching collection report:", error);
      } finally {
        // setLoading(false);
      }
    };

    fetchCollections();
  }, []);

useEffect(() => {
    const superAdminId = Number(localStorage.getItem("adminuserId")) || 0;

    const fetchDashboardCollections = async () => {
      try {
        // setLoading(true);
        const res = await axios.get(`https://payyug.in/api/dashboard-collection/api?superAdminId=${superAdminId}`);
       if (res.data?.data) {
          setDashboardCollections({
            today: res.data.data.today || 0,
            weekly: res.data.data.weekly || 0,
            monthly: res.data.data.monthly || 0,
            yearly: res.data.data.yearly || 0,
            total: res.data.data.total || 0,
          });
        }

      } catch (error) {
        console.error("Error fetching collection report:", error);
      } finally {
        // setLoading(false);
      }
    };

    fetchDashboardCollections();
  }, []);

useEffect(() => {
    const superAdminId = Number(localStorage.getItem("adminuserId")) || 0;

    const fetchDashboardPendingCollections = async () => {
      try {
        // setLoading(true);
        const res = await axios.get(`https://payyug.in/api//dashboard-list/?superAdminId=${superAdminId}`);
       if (res.data?.data) {
          setDashboardPendingCollections({
            today: res.data.data.today || 0,
            weekly: res.data.data.weekly || 0,
            monthly: res.data.data.monthly || 0,
            yearly: res.data.data.yearly || 0,
            total: res.data.data.total || 0,
          });
        }

      } catch (error) {
        console.error("Error fetching collection report:", error);
      } finally {
        // setLoading(false);
      }
    };

    fetchDashboardPendingCollections();
  }, []);

// const [totalActiveLoans,setTotalActiveLoans]=useState(0)

const [pendingDisbursement, setPendingDisbursement] = useState({
  todayPendingDisbursement: 0,
  weekPendingDisbursement: 0,
  monthPendingDisbursement: 0,
  yearPendingDisbursement: 0,
  allPendingDisbursement:0
});

const [totalLoans,setTotalLoans]=useState({
  allDisbursement:0,
  allPendingDisburement:0,
})

  const [filters, setFilters] = useState({
    branch: "All Branches",
    period: "Last 30 days",
  });
  const branches = [
    "All Branches",
    "Branch 1",
    "Branch 2",
    "Branch 3",
    "Branch 4",
  ];
  const periods = [
    "Today",
    "This Week",
    "Last 30 days",
    "This Quarter",
    "This Year",
  ];

  const [todayemisize,settodayemisize]=useState(0);

  // fetch disbursement 
const fetchDisbursementByFilter = async (filter) => {
  const superAdminId = localStorage.getItem("adminuserId");
  if (!superAdminId) return;

  try {
    const res = await axios.get(
      "https://payyug.in/api/dashbaord/loan-summery/disbursment",
      {
        params: {
          superAdminId,
          filter, // today | week | month | year
        },
      }
    );

    const data = res?.data?.data;
    if (!data) return;

    setDisbursement((prev) => ({
      ...prev,
      [`${filter}Disbursement`]: data?.disbursed?.amount ?? 0,
    }));

    // setTotalActiveLoans(data?.disbursed?.count ?? 0)

    // setTotalLoans((prev)=>({
    //   ...prev,
    //   [`${filter}Disbursement`]:data?.totalLoans.amount ?? 0
    // }))

    setPendingDisbursement((prev) => ({
      ...prev,
      [`${filter}PendingDisbursement`]:
        data?.pendingDisbursement?.amount ?? 0,
    }));

  } catch (error) {
    console.error(`${filter} Disbursement Fetch Error:`, error);
  }
};

 useEffect(() => {
   const superAdminId = Number(localStorage.getItem("adminuserId")) || 0;

    const fetchEmis = async () => {
      try {
        const res = await axios.get(`https://payyug.in/api/loan-emi/today?superAdminId=${superAdminId}`);
        settodayemisize(res.data.emis.length);
      } catch (err) {
        console.error(err);
      }
    };
    fetchEmis();
  }, []);

useEffect(() => {
  ["today", "week", "month", "year","total"].forEach(fetchDisbursementByFilter);
}, []);


// console.log("today pending disbursement",pendingDisbursement.todayPendingDisbursement)
// console.log("weekly disbursement",disbursement.weeklyDisbursement)

// collection and disbursment overview
const collDisOverview = [
  {
    icon: "fa-solid fa-hand-holding-dollar",
    class: "cd-collection",
    label: "Collection",
    names: ["Today", "Weekly", "Monthly", "Yearly","Total"],
    values: [
      formatAmount(dashboardCollections.today),
      formatAmount(dashboardCollections.weekly),
      formatAmount(dashboardCollections.monthly),
      formatAmount(dashboardCollections.yearly),
      formatAmount(dashboardCollections.total),
    ],
  },
  {
    icon: "fa-solid fa-hourglass-half",
    class: "cd-pending-collection",
    label: "Pending Collection",
    names: ["Today", "Weekly", "Monthly", "Yearly","Total"],
    values: [
      formatAmount(dashboardPendingCollections.today),
      formatAmount(dashboardPendingCollections.weekly),
      formatAmount(dashboardPendingCollections.monthly),
      formatAmount(dashboardPendingCollections.yearly),
      formatAmount(dashboardPendingCollections.total),
    ],
  },
  {
    icon: "fa-solid fa-arrow-up-right-dots",
    class: "cd-disbursement",
    label: "Disbursement",
    names: ["Today", "Weekly", "Monthly", "Yearly","Total"],
    values: [
      disbursement.todayDisbursement,
      disbursement.weekDisbursement,
      disbursement.monthDisbursement,
      disbursement.yearDisbursement,
      disbursement.allDisbursement
    ],
  },
  {
    icon: "fa-solid fa-clock-rotate-left",
    class: "cd-pending-disbursement",
    label: "Pending Disbursement",
    names: ["Today", "Weekly", "Monthly", "Yearly","Total"],
    values: [
      pendingDisbursement.todayPendingDisbursement,
      pendingDisbursement.weekPendingDisbursement,
      pendingDisbursement.monthPendingDisbursement,
      pendingDisbursement.yearPendingDisbursement,
      pendingDisbursement.allPendingDisbursement
    ],
  },
];


// Balance Overview
const balanceOverview = [
  {
    id: "totalBranches",
    label: "Total Branches",
    value: totalBranches || 0,
    icon: "fa-solid fa-code-branch",
    iconClass: "bo-branches",
  },
  // {
  //   id: "totalBalance",
  //   label: "Total Balance",
  //   value: 0,
  //   icon: "fa-solid fa-wallet",
  //   iconClass: "bo-total",
  // },
  {
    id: "totalCustomer",
    label: "Total Customers",
    value: totalCustomer || 0,
    icon: "fa-solid fa-users",
    iconClass: "bo-customers",
  },
  {
    id: "employee",
    label: "Total Employees",
    value: totalEmployee || 0,
    icon: "fa-solid fa-user-tie",
    iconClass: "bo-employee",
  },
  {
    id: "activeLoans",
    label: "Total Active Loans",
    value: totalActiveLoans || 0,
    icon: "fa-solid fa-wallet",
    iconClass: "bo-loans",
  },
  {
    id: "pendingLoans",
    label: "Total Pending Loans",
    value: totalPendingLoans || 0,
    icon: "fa-solid fa-wallet",
    iconClass: "bo-loans",
  },
  // {
  //   id: "cashbook",
  //   label: "Cashbook",
  //   value: 0,
  //   icon: "fa-solid fa-money-bill-wave",
  //   iconClass: "bo-cashbook",
  // },
  // {
  //   id: "bankbook",
  //   label: "Bankbook",
  //   value: 0,
  //   icon: "fa-solid fa-building-columns",
  //   iconClass: "bo-bankbook",
  // },
  // {
  //   id: "charges",
  //   label: "Charges",
  //   value: 0,
  //   icon: "fa-solid fa-file-invoice-dollar",
  //   iconClass: "bo-charges",
  // },
  {
    id: "collection",
    label: "Today Collection",
    // value: `₹${formatAmount(dashboardCollections.total) || 0}`,
    value: `₹${formatAmount(dashboardCollections.today) || 0}`,
    icon: "fa-solid fa-hand-holding-dollar",
    iconClass: "bo-collection",
  },
  {
    id: "disbursement",
    label: "Total Yearly Disbursement",
    value: "Total Collection",
    value: `₹${formatAmount(disbursement.yearDisbursement) || 0}`,
    icon: "fa-solid fa-arrow-up-right-dots",
    iconClass: "bo-disbursement",
  },
  {
    id: "disbursement",
    label: "Today Due EMI",
    value: "Today EMI",
    value: `${todayemisize || 0}`,
    icon: "fa-solid fa-file-invoice-dollar",
    iconClass: "bo-disbursement",
  },
  // {
  //   id: "outstanding",
  //   label: "Outstanding",
  //   value: 0,
  //   icon: "fa-solid fa-clock-rotate-left",
  //   iconClass: "bo-outstanding",
  // },
   
];


// getting company details
  const [company, setCompany] = useState({
    name: "",
  });

  const getDomainInfo = () => {
    const hostname = window.location.hostname;
    const parsed = parse(hostname);
    return {
      domain: parsed.domainWithoutSuffix || "",
      subdomain: parsed.subdomain || "",
    };
  };

  useEffect(() => {
    const { domain } = getDomainInfo();
    const fetchCompany = async () => {
      try {
        const response = await axios.get("https://payyug.in/api/get-company", {
          params: { domain },
        });
        const data = response.data;
        if (data && Object.keys(data).length > 0) {
          setCompany((prev) => ({
            ...prev,
            name: data.name || prev.name,
          }));
        }
      } catch (err) {
        console.error("Company fetch failed:", err);
      }
    };
    fetchCompany();
  }, []);


  // getting datas for Balance Overview
  useEffect(() => {
    const superAdminId = Number(localStorage.getItem("adminuserId")) || 0;

    const fetchBalanceOverview = async () => {
      try {
        // setLoading(true);
        const res = await axios.get(`https://payyug.in/api/all-dashboard/customer?superAdminId=${superAdminId}`);
       if (res.data) {
         console.log(res.data);
         setTotalBranches(res.data.data.totalBranches);
         setTotalCustomer(res.data.data.totalCustomers);
         setTotalEmployee(res.data.data.totalEmployees);
         setTotalActiveLoans(res.data.data.loans.active);
         const totalpending=res.data.data.loans.others.Approved+res.data.data.loans.others.PENDING;
         setTotalPendingLoans(totalpending);
        }

      } catch (error) {
        console.error("Error fetching Balance Overview:", error);
      } 
    };

    fetchBalanceOverview();
  }, []);

  const toTitleCase = (str = "") =>
  str
    .toLowerCase()
    .replace(/\b\w/g, char => char.toUpperCase());



  return (
    <>
      <div className="admin-dashboard-container">
        <div className="admin-dashboard-heading" style={{ "--chars": 12+company?.name?.length }} >
          {/* <h1>Admin Dashboard</h1> */}
          {/* <h1 className="typewriter-stop" >Welcome, {toTitleCase(company?.name)}</h1> */}
            <h1 className="scroll-rtl" >Welcome, {company?.name}</h1>
        </div>

        {/* ---------------top-filter-section------------- */}
        <div className="admin-dashboard-filter-container">
          {/* <button>Applied</button> */}

          <div className="filter-search">
            <input type="search" placeholder="Search..." />
          </div>

          <div className="filter-dropdowns">
            <select
              value={filters.branch}
              onChange={(e) =>
                setFilters((f) => ({ ...f, branch: e.target.value }))
              }
            >
              {branches.map((b) => (
                <option key={b}>{b}</option>
              ))}
            </select>
            <select
              value={filters.period}
              onChange={(e) =>
                setFilters((f) => ({ ...f, period: e.target.value }))
              }
            >
              {periods.map((p) => (
                <option key={p}>{p}</option>
              ))}
            </select>
          </div>
        </div>

        {/* ------------quick Access------------ */}
        <div className="admin-dashboard-quick-access-container">
          <div className="quick-access-heading">
            <h1>Quick Access</h1>
          </div>
          <div className="quick-access-grids">
            {quickAccess.map((qa, index) => (
              <button
                type="button"
                key={qa.id || index}
                className={`quick-access-divs ${qa.className}`}
                onClick={() => navigate(qa.link)}
              >
                <div className="icon">
                  <i className={qa.icon}></i>
                </div>
                <div className="label">{qa.label}</div>
              </button>
            ))}
          </div>
        </div>

        {/* ------------balance overview------------ */}
        <div className="admin-dashboard-balance-overview-container">
          <div className="balance-overview-heading">
            <h1>Balance Overview</h1>
          </div>
          <div className="balance-overview-grids">
            {balanceOverview.map((bo, index) => (
              <div key={index} className="balance-overview-card">
                <div className={`balance-overview-card-icon ${bo.iconClass}`}>
                  <i className={bo.icon}></i>
                </div>
                <div className="balance-overview-card-data">
                  <p className="card-data-name">{bo.label}</p>
                  <p className="card-data-value">{bo.value}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* -------------collection and disbursal overview--------------- */}
        <div className="admin-dashboard-collection-disbursal-overview-container">
          <div className="collection-disbursal-overview-heading">
            <h1>Collection & Disbursal Overview</h1>
          </div>

          <div className="collection-disbursal-grids">
            {collDisOverview.map((cd, index) => (
              <div
                key={index}
                className={`collection-disbursal-cards ${cd.class}`}
              >
                {/* Icon */}
                <div className="collection-disbursal-card-top">
                  <i
                    className={`${cd.icon} collection-disbursal-card-icon`}
                  ></i>
                  <h4 className="card-title">{cd.label}</h4>
                </div>

                {/* Card Content */}
                <div className="collection-disbursal-card-values">
                  {cd.names.map((name, i) => (
                    <div
                      key={i}
                      className="collection-disbursal-card-value-row"
                    >
                      <p className="card-data-name">{name}</p>
                      <p className="card-data-value">₹{cd.values[i]}</p>
                      {/* <p className="card-data-value">₹{cd.values[i]}</p> */}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* -----------recent collection------------- */}
        <div className="admin-dashboard-recent-collection-container">
          <div className="recent-collection-heading">
            <h1>Recent Collection <span style={{fontSize:"14px"}}>(Last 5 Collections)</span></h1>
          </div>

          <div className="recent-collection-table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Date</th>
                  <th>Name</th>
                  <th>Amount</th>
                  {/* <th>Mode</th>
                  <th>Collector</th> */}
                </tr>
              </thead>
              <tbody>
                {collections.slice(0, 5).map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>
                    <td>{item.paymentDate ? new Date(item.paymentDate).toLocaleDateString("en-IN") : "-"}</td>
                    <td>{item.customerName}</td>
                    <td>₹{item.emiAmount.toLocaleString()}</td>
                    {/* <td>{item.mode}</td>
                    <td>{item.collector}</td> */}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
